import {
  getAllChildrenStrings,
  getHeadingId,
} from '@ria-client/supergraph/structuredContent/table-of-contents';
import { Fragment } from 'react';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

const HEADING_CLASSES = {
  1: 'typography-content-title',
  2: 'typography-text-large-bold',
  3: 'typography-text-large',
  4: 'typography-text-bold',
  5: 'typography-text',
  6: 'typography-text-small',
} as const;

export type ContentHeadingProps = NodeProps<{
  children: StructuredContent | StructuredContent[];
  excludeFromTOC?: boolean;
  level: 1 | 2 | 3 | 4 | 5 | 6;
  size?: 0 | 1 | 2 | 3 | 4 | 5;
}> & { nested?: boolean };

export function ContentHeading({ nested, props, ...doc }: ContentHeadingProps) {
  const Tag = `h${props.level}` as const;
  const childrenString = getAllChildrenStrings({ ...doc, props });

  return (
    <Tag
      className={`${HEADING_CLASSES[props.level]} [&_*]:!font-[inherit] [&_*]:!text-[inherit] [&_*]:!leading-[inherit]`}
      data-content-heading=""
      id={childrenString ? getHeadingId(childrenString) : ''}
    >
      {[props.children].flat().map((child, index) => {
        if (typeof child === 'string') return <Fragment key={index}>{child}</Fragment>;
        if (child) return <StructuredContentRenderer doc={child} nested={nested} key={index} />;
        return null;
      })}
    </Tag>
  );
}
